import {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T194698-home-page-aa-test': 'control',
  'T194698-home-page-aa-test-v1': 'control',
  'T220554-home-page-seo-navbar-webapp-v1': 'control',
};

export const userExperiments: Partial<UserExperiments> = {
  'T214387-freelancer-suggested-milestones': 'control',
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T58186-giveget-delayed-payment-verify-v2': 'control',
  'T90189-image-thumbnail-service': 'control',
  'T183128-projects-amount-overview-on-dashboard': 'control',
  'T178308-freelancer-my-projects-empty-state-V2': 'control',
  'T194666-hourly-initial-payment': 'control',
  'T211099-webapp-user-search': 'control',
  'T215326-navigation-revamp-phase-1': 'control',
  webapp_playground_test: 'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {
  'T216398-client-suggested-milestones': 'control',
};

export const isWhitelistUser = false;

export const shouldEnrol = true;
